module.exports = __webpack_public_path__ + "img/weixin_2.e55ba6d8.png";